module.exports = window["@wix/pro-gallery-renderer"];